/**
 * posthog-js autocapture class. Any element (and its subtree) carrying this
 * class is skipped by autocapture, dead-click, and rageclick detection.
 * @see https://posthog.com/docs/product-analytics/privacy
 */
export const PH_NO_CAPTURE_CLASS = 'ph-no-capture';

/**
 * Creates the throwaway `<a>` we append to the body, click, and remove to
 * trigger a browser download.
 *
 * The anchor is marked `ph-no-capture` so posthog-js ignores the synthetic
 * `link.click()`. A multi-file download loop creates one anchor per file and
 * clicks each in quick succession at the same DOM position; without this,
 * those synthetic clicks are logged as `$rageclick` / `$dead_click` — a false
 * "user is stuck" signal for a download that actually worked. This marks the
 * instrumentation, it does not change what gets downloaded.
 */
export function createDownloadAnchor(): HTMLAnchorElement {
  const anchor = document.createElement('a');
  anchor.classList.add(PH_NO_CAPTURE_CLASS);
  return anchor;
}
